import "core-js/modules/es.array.join";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.timers";

/**
 * DOM 操作模块
 * @module dom
 */
import { $isServer, $isIOS } from './env';
/**
 * 寻找最近的支持滚动的父节点
 * @method getScrollParent
 * @param {HTMLElement} element 当前节点
 * @param {HTMLElement} [rootParent=window] 根节点
 * @return {HTMLElement}
 */

export function getScrollParent(element, rootParent) {
  if ($isServer) return;
  var node = element;

  while (node && node.tagName !== 'HTML' && node.tagName !== 'BODY' && node.nodeType === 1 && node !== (rootParent || window)) {
    var _window$getComputedSt = window.getComputedStyle(node),
        overflowY = _window$getComputedSt.overflowY;

    if (overflowY === 'scroll' || overflowY === 'auto') {
      return node;
    }

    node = node.parentNode;
  }

  return rootParent || window;
}
/**
 * iOS 收起输入框时滚动修复
 * @see https://developers.weixin.qq.com/community/develop/doc/00044ae90742f8c82fb78fcae56800
 * @method iOSPageScrollFix
 * @example

import { dom } from '@zz-common/zz-utils'

input.addEventListener('blur', () => dom.iOSPageScrollFix())

 */

export function iOSPageScrollFix() {
  if ($isIOS) {
    window.scrollTo(window.pageXOffset, window.pageYOffset);
  }
}
/**
 * 查询节点是否存在某个 class 类名
 * @method hasClass
 * @param {HTMLElement} el 目标节点
 * @param {String} className 类名
 * @return {Boolean}
 */

export function hasClass(el, className) {
  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
  return reg.test(el.className);
}
/**
 * 在节点上添加 class 类名
 * @method addClass
 * @param {HTMLElement} el 目标节点
 * @param {String} className 类名
 */

export function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }

  var newClass = el.className.split(' ');
  newClass.push(className);
  el.className = newClass.join(' ');
}
/**
 * 在节点上删除 class 类名
 * @method removeClass
 * @param {HTMLElement} el 目标节点
 * @param {String} className 类名
 */

export function removeClass(el, className) {
  if (!hasClass(el, className)) {
    return;
  }

  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g');
  el.className = el.className.replace(reg, ' ');
}
/**
 * 加载 js 文件
 * @method loadJs
 * @param {String} url js文件链接
 * @param {Function} callback 回调函数
 */

export function loadJs(url, callback) {
  if ($isServer) return;
  var script = document.createElement('script');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('async', 'async');
  script.setAttribute('src', url);

  if (typeof callback === 'function') {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = callback;
    }
  }

  document.body.appendChild(script);
}
var DEFAULT_INTERVAL = 100 / 60;
/**
 * 解决 requestAnimationFrame 的兼容问题
 * @method requestAnimationFrame
 * @param {Function} callback 回调函数
 * @return {Function} 返回一个 polyfill 后的 raf
 */

export var requestAnimationFrame = function () {
  if ($isServer) return function () {};
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || function (callback) {
    return setTimeout(callback, (callback.interval || DEFAULT_INTERVAL) / 2);
  };
}();
export default {
  getScrollParent: getScrollParent,
  iOSPageScrollFix: iOSPageScrollFix,
  hasClass: hasClass,
  addClass: addClass,
  removeClass: removeClass,
  loadJs: loadJs,
  requestAnimationFrame: requestAnimationFrame
};